<template>
  <div>
    <v-layout v-if="!ocultar_ativador_padrao">
      <h4>
        <Legenda
          titulo="Estoque"
          legenda="Estoque ou saldo é a acumulação armazenada de uma determinada SKU em um ou mais locais de armazenamento"
        >
          <div>
            Estoque

            <v-icon
              v-if="mensagemValidadeLote.vencido"
              small
              color="red"
              :title="'Detalhamento Estoque do Grupo - ' + mensagemValidadeLote.mensagem"
              @click="getDetalhamentoEstoqueGrupo()"
              v-text="'mdi-alert-outline'"
            />

            <v-icon
              v-else-if="mensagemValidadeLote.vencer"
              small
              color="blue"
              :title="'Detalhamento Estoque do Grupo - ' + mensagemValidadeLote.mensagem"
              @click="getDetalhamentoEstoqueGrupo()"
              v-text="'mdi-information-outline'"
            />

            <v-icon
              v-else
              small
              title="Detalhamento Estoque do Grupo"
              @click="getDetalhamentoEstoqueGrupo()"
              v-text="'mdi-information-outline'"
            />
          </div>
        </Legenda>
      </h4>

      <AnalisePorLote
        v-if="flagAnalisePorLote && !produto.produto_eh_combinacao"
        :produto="{ id_grupo: produto.id_grupo, id_produto: produto.idproduto }"
        @update:analise-por-lote="$emit('update:parametrizacao')"
      />
    </v-layout>

    <div v-else @click="getDetalhamentoEstoqueGrupo()">
      <slot name="ativador"></slot>
    </div>

    <v-layout>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
        persistent
      >
        <v-snackbar
          v-model="dialog"
          :timeout="-1"
          :value="true"
          absolute
          right
          shaped
          light
          top
          v-if="mensagemValidadeLote.mensagem"
        >
          <v-icon color="red" v-if="mensagemValidadeLote.vencido">mdi-alert</v-icon>
          <v-icon color="blue" v-else>mdi-information-outline</v-icon>
          {{ mensagemValidadeLote.mensagem }}
        </v-snackbar>

        <v-card>
          <div class="bg-systock-1 px-2 py-3 d-flex align-center">
            <v-btn icon dark @click="fecharDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <span class="text-white font-20 font-weight-regular ml-4">Detalhamento do estoque do grupo</span>

            <ConverterEmbalagem class="ml-4" dark />
          </div>

          <div class="d-flex pt-2 pb-3 px-3">
            <h4 class="mt-1">PRODUTO: {{ nomeProduto }}</h4>

            <v-spacer />

            <validade-lotes v-if="buttonValidadeLotes" />
          </div>

          <div id="tabela-itens">
            <v-data-table
              :headers="headers"
              :items="items"
              :fixed-header="true"
              :items-per-page="-1"
              height="calc(100vh - 165px)"
              class="elevation-3 font-resp-tabela table-full-screen mx-1"
            >
              <template v-slot:item="{ item }">
                <tr
                  class="row-table"
                  :class="{'text-gray-100': !item.considerar_estoque, 'text-red': item.status === 'FL'}"
                >
                  <td>Filial {{ item.filial }} {{ item.nome_fantasia ? `- ${item.nome_fantasia}` : '' }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_minimo)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_bloqueado)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_avaria)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_reservado)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_seguranca)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.ponto_pedido)) }}</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.estoque_maximo)) }}</td>
                  <td>{{ Helpers.formatarValor(item.cobertura_estoque) }} dias</td>
                  <td>{{ Helpers.formatarValor(converteEmbalagemValor(item, item.consumo_medio_mensal)) }}</td>
                </tr>
              </template>

              <template #footer.prepend>
                <div class="d-flex align-center">
                  <div class="bg-red quadrado-15 mr-1">&nbsp;</div>
                  Fora de linha
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CompraAPI from "./../../../api/compra";
import validadeLotes from "./ValidadeLotes";
import ConverterEmbalagem from "../Embalagem/ConverterEmbalagem";
import AnalisePorLote from '@/components/produto/detalhes/AnalisePorLote/Index.vue';
import api from "@/api/api.js";
import Legenda from "@/components/produto/detalhes/Legenda.vue";

export default {
  components: {
    Legenda,
    ConverterEmbalagem,
    validadeLotes,
    AnalisePorLote
  },
  props: {
    produto: Object,
    ocultar_ativador_padrao: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    items: [],
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Estoque", value: "estoque" },
      { text: "Estoque Estético", value: "estoque_minimo" },
      { text: "Estoque Bloqueado", value: "estoque_bloqueado" },
      { text: "Estoque Avaria", value: "estoque_avaria" },
      { text: "Estoque Reservado", value: "estoque_reservado" },
      { text: "Estoque Segurança", value: "estoque" },
      { text: "Ponto Pedido", value: "ponto_pedido" },
      { text: "Estoque Máximo", value: "estoque_maximo" },
      { text: "Cobertura Estoque", value: "cobertura_estoque" },
      { text: "Projeção de vendas", value: "consumo_medio_mensal" },
    ],
    mensagemValidadeLote: false,
    buttonValidadeLotes: null,
    flagAnalisePorLote: false
  }),
  computed: {
    ...mapGetters({
      activityLog: "activityLog/getLog",
      embalagemMasterAtivada: "EmbalagemTelaDeCompras/getEmbalagemMaster",
    }),
    nomeProduto() {
      const FUNCTION = this.activityLog.function;

      if (typeof this[FUNCTION] == "function") {
        const {
          idproduto,
          descricao_produto,
        } = this.activityLog.properties.attributes;

        return `${idproduto} - ${descricao_produto}`;
      }

      return `${this.produto.idproduto} - ${this.produto.descricao_produto}`;
    },
  },
  created() {
    this.validadesLotes();
  },
  mounted() {
    this.buscarFlagAnalisePorLote();
  },
  watch: {
    activityLog() {
      this.refazerAtividade();
    },
    produto(novo, antigo) {
      if (novo.idproduto != antigo.idproduto) {
        this.validadesLotes();
      }
    }
  },
  methods: {
    buscarFlagAnalisePorLote() {
      api.get('compras/produtos/analise-por-lotes/flag').then(response => {
        this.flagAnalisePorLote = response.data.flag;
      });
    },
    validadesLotes() {
      if (localStorage.confHabilitarLoteProduto === 'false') {
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        idproduto: this.produto.idproduto,
        grupo: this.produto.id_grupo,
        filial: this.produto.filial,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getNotificacaoProdutoValidadeLotes(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.mensagemValidadeLote = response.data.msg_validade_lotes;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.Helpers.logout();
        })
      );
    },
    refazerAtividade: function () {
      const FUNCTION = this.activityLog.function;

      if (typeof this[FUNCTION] == "function") {
        this[FUNCTION](this.activityLog.properties.attributes);
      }
    },
    fecharDialog: function () {
      this.dialog = false;
      this.$store.dispatch("activityLog/resetLog");
    },
    getDetalhamentoEstoqueGrupo: function (prodLog = {}) {
      this.dialog = true;
      const headers = this.Helpers.iniciarRequisicao();

      const filialCompra = this.produto.filial <= -1 ? 0 : this.produto.filial

      const produto_eh_combinacao = prodLog.produto_eh_combinacao || this.produto.produto_eh_combinacao;
      const produto_eh_categoria = prodLog.produto_eh_categoria || this.produto.produto_eh_categoria;

      const params = {
        grupoCompra: prodLog.grupoCompra || this.produto.id_grupo,
        idproduto: prodLog.idproduto || this.produto.idproduto,
        filialCompra: prodLog.filialCompra || filialCompra,
        produtos: prodLog.produtos || this.produto.produtos,
        produto_eh_combinacao: produto_eh_combinacao ? 'S' : 'N',
        produto_eh_categoria: produto_eh_categoria ? 'S' : 'N',
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getDetalhamentoEstoqueGrupo(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          this.items = response.data.detalheEstoqueGrupo;
          this.buttonValidadeLotes = response.data.buttonValidadeLotes;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.Helpers.logout();
        })
      );
    },
    converteEmbalagemValor(produto, valor) {
      if (produto.tipo_fator_conversao === 'M') {
        return this.embalagemMasterAtivada ? (valor * produto.multiplo_compra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor / produto.multiplo_compra) : valor;
    },
  },
};
</script>
<style scoped>
</style>
